// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import "firebase/auth";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getMessaging, getToken } from "firebase/messaging";

const apiKey = process.env.REACT_APP_API_KEY_PROD;
const authDomain = process.env.REACT_APP_authDomain_PROD;
const projectId = process.env.REACT_APP_projectId_PROD;
const storageBucket = process.env.REACT_APP_storageBucket_PROD;
const messagingSenderId = process.env.REACT_APP_messagingSenderId_PROD;
const appId = process.env.REACT_APP_appId_PROD;
const measurementId = process.env.REACT_APP_measurementId_PROD;
const vapidKey = process.env.REACT_APP_vapidKey_PROD;

// const firebaseConfig = {
//     apiKey: "AIzaSyC_t9Jq9x2W_65mKFkK7XgUTz0RiCY_-TI",
//     authDomain: "curry-king-prod-454216.firebaseapp.com",
//     projectId: "curry-king-prod-454216",
//     storageBucket: "curry-king-prod-454216.firebasestorage.app",
//     messagingSenderId: "803543880665",
//     appId: "1:803543880665:web:298c340e6cc9715b277fc8",
//     measurementId: "G-KBWD82RCEY"
// };
const firebaseConfig = {
    apiKey: apiKey,
    authDomain: authDomain,
    projectId: projectId,
    storageBucket: storageBucket,
    messagingSenderId: messagingSenderId,
    appId: appId,
    measurementId: measurementId
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
export const auth = getAuth(app);
export const db = getFirestore(app);

/**
 * Generate Firebase Cloud Messaging token.
 * @returns {Promise<string | null>} FCM token or null if an error occurs.
 */

export const generateToken = async () => {
    try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
            const token = await getToken(messaging, {
                // vapidKey: "BC_ZSTe1jdHglsQrRJUyxFqD4haZnh7fHZUD7dBuUDPlQcNl3p34C_lOmXBaBTEnKh-VxvW4obMZe4nGXgpDY_I",
                vapidKey: vapidKey,
            });
            if (token) {
                return token;
            }
        }
        console.error("Notification permission not granted.");
        return null;
    } catch (error) {
        console.error("Error generating FCM token:", error);
        return null;
    }
};



